import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);
const API_BASE_URL_AUTH = process.env.REACT_APP_API_BASE_URL_AUTH;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    const storedUser = localStorage.getItem('user');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    axios.defaults.baseURL = API_BASE_URL_AUTH;

    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
    };
  }, [token]);

  useEffect(() => {
    axios.defaults.baseURL = API_BASE_URL;

    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
    };
  }, [token]);

  
  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL_AUTH}/api/Auth/login`, {
        email,
        password
      });

      const data = response.data;

       
      

      localStorage.setItem('authToken', data.token);
      
      const userData = {
        userId: data.user.id,
        companyId: data.user.companyId,
        email: data.user.email,
        firstName: data.user.firstName,
        lastName: data.user.lastName,
        phoneNumber: data.user.phoneNumber,
        role: data.user.role,
        fullName: `${data.user.firstName} ${data.user.lastName}`,
        warehouseId: data.user.warehouseId
      };
      
      localStorage.setItem('user', JSON.stringify(userData));
      setToken(data.token);
      setUser(userData);
      
      return { success: true, message: data.message,user: userData };
    } catch (error) {
      console.error('Login error:', error);

      const errorMessage = error.response?.data?.message || error.message || 'Login failed';
      return { success: false, error: errorMessage };
    }
  };

  const SuperAdminLogin = async (username, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL_AUTH}/api/Auth/login/superAdmin`, {
        username,
        password
      });

      const data = response.data;

       
      

      localStorage.setItem('authToken', data.token);
      
      const userData = {
        userId: data.user.id,
        username: data.user.username,
        firstName: data.user.firstName,
        lastName: data.user.lastName,
        phoneNumber: data.user.phoneNumber,
        role: data.user.role,
        fullName: `${data.user.firstName} ${data.user.lastName}`,
        warehouseId: data.user.warehouseId
      };
      
      localStorage.setItem('user', JSON.stringify(userData));
      setToken(data.token);
      setUser(userData);
      
      return { success: true, message: data.message };
    } catch (error) {
      console.error('Login error:', error);

      const errorMessage = error.response?.data?.message || error.message || 'Login failed';
      return { success: false, error: errorMessage };
    }
  };

  const register = async (registrationData) => {
    try {
      const response = await axios.post(`${API_BASE_URL_AUTH}/api/Auth/register`,
        registrationData
      );

      const data = response.data;
     
      return { 
        success: true, 
        message: data.message,
        requiresVerification: true 
      };
    } catch (error) {
      console.error('Registration error:', error);

      const errorMessage = error.response?.data?.message || error.message || 'Registration failed';
      return { success: false, error: errorMessage };
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    sessionStorage.clear();
    setToken(null);
    setUser(null);
  };

  const value = {
    user,
    token,
    loading,
    login,
    register,
    logout,
    isAuthenticated: !!token,
    isAdmin: user?.role === 'admin',
    isMerchandiser: user?.role === 'Merchandiser',
    isSuperAdmin: user?.role === process.env.REACT_APP_SUPER_ADMIN_ROLE,
    API_BASE_URL
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};